import "./Loader.scss";
import { TiWiFi } from "react-icons/ti";
import React, { useState } from "react";

const MIN_VISIBLE = 250;
export let LoaderGlobal;

export const Loader = () => {
  const [state, setState] = useState({ shown: false, hidden: true });

  LoaderGlobal = {
    show: () => {
      setState({ shown: true, hidden: false });
      setTimeout(
        () => setState((state) => ({ ...state, shown: false })),
        MIN_VISIBLE
      );
    },
    hide: () => setState((state) => ({ ...state, hidden: true })),
  };

  return (
    (state.shown || !state.hidden) && (
      <div className="glass" onTouchEnd={(event) => event.stopPropagation()}>
        <TiWiFi style={{ fill: "orange", width: "50px", height: "50px" }} />
      </div>
    )
  );
};
